import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDownload$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDownload extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '14e3e3180a1658955aee8f02a49ecfe5200d2697', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'dd47966c91df13df171379cdd23f276339d35ab9', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e3002224b53d62acf388f70623a3b4a0ef562cda', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.75 10H15a.4.4 0 0 1 .33.68l-4.05 4a.4.4 0 0 1-.56 0l-4-4A.4.4 0 0 1 7 10h3.25V4.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5zM5.5 17.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-download", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-download"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-download":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDownload$1);
            }
            break;
    } });
}

const CosmosIconDownload = CosmosIconDownload$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDownload, defineCustomElement };
